var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: { id: "PTVHistoryModal", size: "xl" },
          on: {
            show: function ($event) {
              return _vm.getHistory()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "modal-header",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-between w-100",
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "mb-0 font-weight-semibold text-white" },
                        [_vm._v("Interface Release History")]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-row",
                    { staticClass: "w-100 justify-content-end" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "close-btn px-4 py-2",
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _c("vue-good-table", {
            staticClass: "m-2",
            attrs: {
              id: "PTV-Releases",
              rows: _vm.releaseRows,
              columns: _vm.releaseColumns,
              "pagination-options": _vm.pagination,
              styleClass: "vgt-table striped max-height-60",
            },
            scopedSlots: _vm._u([
              {
                key: "table-row",
                fn: function (props) {
                  return [
                    props.column.field == "release_date" &&
                    props.row.release_date != null
                      ? _c("span", { staticStyle: { width: "50px" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                new Date(
                                  props.row.release_date
                                ).toLocaleDateString()
                              ) +
                              "\n        "
                          ),
                        ])
                      : _c("span", { staticStyle: { width: "50px" } }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.row[props.column.field]) +
                              "\n        "
                          ),
                        ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }